/* global axios */
import ApiClient from './ApiClient';

class FollowUpEnrollmentsAPI extends ApiClient {
  constructor() {
    super('follow_up_enrollments', { accountScoped: true });
  }

  lookup(contactIds) {
    return axios.get(this.url, { params: { contact_ids: contactIds } });
  }
}

export default new FollowUpEnrollmentsAPI();
